/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:800px){.container-scroller[_ngcontent-%COMP%]{padding-bottom:60%!important}}@supports (-webkit-touch-callout:none){  .modal-content .daily-changes-wrapper,   .modal-content .diary-training-wrapper,   .modal-content .external-meals-wrapper,   .modal-content .shopping-list-wrapper,   .modal-content .upgrade-wrapper,   .modal-content .wrapper{padding-top:40px!important}}"];
export { styles as styles };
